// Workaround for: https://github.com/bazelbuild/rules_nodejs/issues/1265
/// <reference types="google.maps" />

import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { NonNullDynamicState, SelectorUtil, SerializablePosition } from '@us/web/shared/data-access';
import { PositionActions } from './position.actions';

export const POSITION_FEATURE_KEY = 'position';

export interface State extends NonNullDynamicState<'position', SerializablePosition | null> {
    positionRequested: boolean;
    geocoderResult: google.maps.GeocoderResult | null;
}

export const initialState: State = {
    position: null,
    positionRequested: false,
    geocoderResult: null,
    status: 'pending',
    error: null
};

export const positionFeature = createFeature({
    name: POSITION_FEATURE_KEY,
    reducer: createReducer(
        initialState,
        on(
            PositionActions.requestPosition,
            (state): State => ({
                ...state,
                positionRequested: true
            })
        ),
        on(PositionActions.getGeocode, (state): State => ({ ...state, status: 'loading' })),
        on(
            PositionActions.getGeocodeSuccess,
            (state, { geocode }): State => ({
                ...state,
                geocoderResult: geocode.results[0],
                status: 'success'
            })
        ),
        on(PositionActions.getGeocodeFailure, (state): State => ({ ...state, status: 'error' })),
        on(
            PositionActions.selectGeocode,
            (state, { geocoderResult }): State => ({
                ...state,
                geocoderResult
            })
        )
    )
});

export const { selectPositionState, selectPosition, selectPositionRequested, selectGeocoderResult } = positionFeature;

export const selectCurrentLocation = createSelector(
    selectGeocoderResult,
    geocode => geocode?.geometry.location as { lat: number; lng: number } | undefined
);

export const selectCurrentAddress = createSelector(
    selectGeocoderResult,
    geocode => geocode?.formatted_address as string | undefined
);

export const selectIsLoadingGeocode = createSelector(selectPositionState, SelectorUtil.isLoading);
